import { Link } from "react-router-dom";
import { LOGO_URL, CONTACT } from "../data";
import { usePartner } from "../PartnerContext";
import { Mail, Phone, MessageCircle } from "lucide-react";

export const Footer = () => {
  const { whatsappLink } = usePartner();
  return (
    <footer className="border-t border-white/10 bg-[#05070D] px-5 py-14 md:px-10">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-3">
              <img src={LOGO_URL} alt="TSU-Partners" className="h-11 w-11 rounded-xl object-cover ring-1 ring-white/15" />
              <span className="font-heading text-lg font-extrabold text-white">
                TSU<span className="gradient-text">-PARTNERS</span>
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm text-gray-400">
              Werde Fahrzeugüberführer in Deutschland, Österreich und der Schweiz. Vom ersten Auftrag bis zum stabilen
              Einkommen.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-white">Kontakt</h4>
            <ul className="mt-4 space-y-3 text-sm text-gray-400">
              <li className="flex items-center gap-2.5">
                <Mail className="h-4 w-4 text-[#60A5FA]" />
                <a href={`mailto:${CONTACT.email}`} className="hover:text-white" data-testid="footer-email">{CONTACT.email}</a>
              </li>
              <li className="flex items-center gap-2.5">
                <Phone className="h-4 w-4 text-[#60A5FA]" />
                <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="hover:text-white">{CONTACT.phone}</a>
              </li>
              <li className="flex items-center gap-2.5">
                <MessageCircle className="h-4 w-4 text-[#60A5FA]" />
                <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="hover:text-white" data-testid="footer-whatsapp">
                  WhatsApp: Schreib uns direkt
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-white">Rechtliches</h4>
            <ul className="mt-4 space-y-3 text-sm text-gray-400">
              <li><Link to="/impressum" className="hover:text-white" data-testid="footer-impressum">Impressum</Link></li>
              <li><Link to="/datenschutz" className="hover:text-white" data-testid="footer-datenschutz">Datenschutz</Link></li>
              <li><a href="#vorteile" className="hover:text-white" data-testid="footer-vorteile">Vorteile</a></li>
              <li><a href="#faq" className="hover:text-white" data-testid="footer-faq">FAQ</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-white/10 pt-6 text-center text-sm text-gray-500">
          © {new Date().getFullYear()} {CONTACT.company}. Alle Rechte vorbehalten.
        </div>
      </div>
    </footer>
  );
};
